<template>
<div class="container px-0" id="UserDashboard">
	
	<div class="page-header gold mt-4 mb-2">

    <back-btn to="/dashboard"></back-btn>

    <h3 class="mb-0"><span v-text="this.$route.meta.title"></span></h3>
	</div>

  <Shortcuts v-if="$route.meta.showShortcuts"></Shortcuts>

	<div v-if="page_loaded == 0" class="text-center mt-5 gold">
		<i class="fas fa-spinner fa-spin fa-2x"></i>
		<p>Loading...</p>
	</div>
	<div v-else>

    <MeditationStreak v-if="$route.meta.category == 'meditation'"></MeditationStreak>

		<div
			v-for="section in dashboard"
			:key="section.slug"
			:id="section.slug"
		>
			<div v-if="section.cards && section.cards.length > 0">
				
				<div class="mb-4">
					
					<h4 class="text-muted p-2">
						
						<i :class="section.icon" class="mr-2"></i>
						<span v-text="section.title"></span>
						<small v-if="section.slug != 'charts' && !$route.meta.hideForumLink" class="ml-2">
							<router-link :to="'/forum/categories/' + section.slug" class="gold small">
								<i class="far fa-comments"></i> forum
							</router-link>
						</small>
					</h4>
					
					
					<div class="card-grid" :id="'section_' + section.slug">

						<b-card
							v-for="card in section.cards"
							:key="card.slug"
							class="dashboard-card"
						>
							<template #header>
								<div class="row">
									<div class="col text-left small">
										<div v-if="card.card_type === 'forum'" class="">
											<span v-text="card.title"></span>
										</div>
										<div v-else v-text="card.title"></div>
									</div>
									<div v-if="card.access" class="col-4 text-right small">
										<small v-text="card.access.date"></small>
									</div>
								</div>
							</template>
							
							
							
							
							<div v-if="card.component && typeof card.component !== 'undefined'">
								
								<div v-if="card.overview_text !== 'undefined'" class="mb-1">
									<ul 
										v-for="(item, index) in card.overview_text" 
										:key="index" class="mb-0 pl-4"
									>
										<li v-html="item" class="small"></li>
									</ul>
								</div>
						
								<div v-if="card.component === 'ChartLine'">
									<div v-if="!card.hasChartData" class="no-data-state">
										<i class="fas fa-chart-line no-data-state__icon"></i>
										<p class="no-data-state__text">Nothing to show for the last 7 days</p>
									</div>
									<div v-else>
										<chart-line :chartdata="card.chartdata" />
									</div>
								</div>

								<div v-if="card.component === 'CountdownTimer'" class="timer-wrap">
									<countdown-timer />
								</div>
								
								<div v-if="card.component === 'MeditationManualLog'" class="text-center">
									<meditation-manual-log />
								</div>
								
								<div v-if="card.component === 'DreamsLog'" class="text-center">
									<dreams-log />
								</div>
								
								<div v-if="card.component === 'FeelingsLog'" class="text-center">
									<feelings-log />
								</div>

								<div v-if="card.component === 'CourseCard'">
									<course-card :data="card" />
								</div>

								<div v-if="card.component === 'ForumItem'" class="text-left">
									<div
										v-if="(card.youtube && card.youtube.length > 0) || (card.vimeo && card.vimeo.length > 0)" 
										class="mb-2"
									>
										<video-embeds :embeddata="card" classW="" show_title="0" />
									</div>
									
									
									
									<div v-if="card.main_text !== null"  class="">
										<p class="card-text" v-html="card.main_text"></p>
										<p 
											@click="onClick($event, card, 'description')"
											class="text-right pointer gold small"
										><i class="fas fa-minus"></i> less</p>
									</div>
									<div v-else-if="card.description" class="" >
										<p class="card-text" v-html="card.description"></p>
										<p 
											@click="onClick($event, card, 'main_text')"
											class="text-right pointer gold small"
										><i class="fas fa-plus"></i> more</p>
									</div>
									
									
									<div v-if="card.list && card.list.items" class="card-body">
										<ul v-for="item in card.list.items" :key="'L_' + item.date" class="list-unstyled mb-0">
											<dl class="row small">
												<dt class="col-7"><small v-text="item.date"></small></dt>
												<dd class="col-3"><span v-text="item.mins"></span><small>min</small></dd>
											</dl>
										</ul>
									</div>
								</div>
									
							</div>
							
							
							<template #footer>
								<div v-if="card.can_comment && card.can_comment === 1" class="" :id="'reply_' + card.id">
									<div class="row">
										<div class="col text-left">
											<small 
												v-if="!card.reply_open || card.reply_open === 0"
												class="col gold pointer text-left"
												@click="onClick($event, card, 'replys')"
											>
												<i class="far fa-comments"></i> <span v-text="card.replies_count"></span> comments
											</small>
											<small 
												v-else
												class="col gold pointer text-left" @click="onClick($event, card, 'close_comment')">
												<i class="far fa-times-circle"></i> close comments 
											</small>
										</div>
										<div v-if="card.user_name" class="col text-right">
											<small 
												class="text-muted"
												v-text="card.user_name"
											></small>
										</div>
									</div>
								</div>
								<div v-else class="">
									<div class="row">
										<div class="col text-left">
											<small class="text-muted mr-2"></small>
										</div>
										<div v-if="card.user_name" class="col text-right">
											<small 
												class="text-muted"
												v-text="card.user_name"
											></small>
										</div>
									</div>
								</div>
							</template>
							
						</b-card>
						
					
					</div>



				</div>
			</div>
			
		</div>
		
	</div>
	
	
	
	<b-modal 
		id="comments_wrapper" 
		title="Comments / Reply" 
		size="xl"
	>
	
		<div v-if="active_card.id">	
				
			<div v-if="active_card.replies !== null" class="text-left mb-3">
				<ul class="list-group" v-for="R in active_card.replies" :key="'R_' + R.id">
					<li class="list-group-item">
						<span v-text="R.title"></span> <span v-html="R.main_text"></span><br />
						<div
							v-if="(R.youtube && R.youtube.length > 0) || (R.vimeo && R.vimeo.length > 0)" 
							class="col-md-4 mb-2"
						>
							<video-embeds :embeddata="R" classW="" show_title="0" />
						</div>
				
						<div class="text-right mt-1 small">
							<b v-text="R.user_name"></b>: 
							<span v-text="R.access.date+' '+R.access.time"></span>
						</div>
					</li>
				</ul>
				
			</div>
			<div v-else class="text-muted">It's a ghost town in here... Start a conversation?</div>
					
					
			
			<div v-if="active_card.can_comment == 1">
				<p class="p-0 m-0 mt-3"><b>Post Reply</b></p>
				<b-form-textarea
					v-model="active_card.reply_text"
					placeholder="Enter something..."
					rows="3"
					max-rows="6"
					class="mt-2"
					@keyup="checkReplyForm"
				></b-form-textarea>
				
				<div class="text-right">
					<h5 v-if="error_message != ''" v-text="error_message" class="text-danger"></h5>
				</div>
			</div>
			
			
    
    
		</div>
		
		
		<template #modal-footer="{ ok, cancel }">
		
			<div v-if="active_card.replys_loaded === 1">
				<button 
					v-if="active_card.can_comment == 1"
					type="button" class="btn btn-primary"
					@click="replyAdd()" 
					:disabled="!canSubmitReply"
				>
					Submit <i class="far fa-comment-dots"></i>
				</button>
				<small v-else class="text-muted mr-2">Comments have been disabled for this post</small>
				
				
				<b-button size="sm" variant="danger" @click="cancel()">
					Cancel
				</b-button>
			</div>
			<div v-else>
				Loading data...
			</div>
			
		</template>

		
	</b-modal>
	
	
	
	
</div>
</template>


<script>
import axios from "@/axios";
import ChartLine from '../components/ChartLine.vue';
import CountdownTimer from '../components/CountdownTimer.vue';
import CourseCard from '../components/CourseCard.vue';
import DreamsLog from '../components/DreamsLog.vue';
import FeelingsLog from '../components/FeelingsLog.vue';
import MeditationManualLog from '../components/MeditationManualLog.vue';
import VideoEmbeds from '../components/VideoEmbeds.vue';
import Shortcuts from "@/components/Dashboard/Shortcuts.vue";
import BackBtn from "@/components/BackBtn.vue";
import MeditationStreak from "@/components/Dashboard/MeditationStreak.vue";



export default {
	name: "UserDashboard",
	components:{
    MeditationStreak,
    BackBtn,
    Shortcuts,
		ChartLine,
		CountdownTimer,
		CourseCard,
		DreamsLog,
		FeelingsLog,
		MeditationManualLog,
		VideoEmbeds,
	},
	data() {
		return {
			active_card: {},
			canSubmitReply: false,
			dashboard: {},
			error_message: '',
			page_loaded: 0,
		}
	},
	computed:{
	},
	methods:{
		
		checkReplyForm(){
			if(this.active_card.reply_text === ''){
				this.canSubmitReply = false;
			} else {
				this.canSubmitReply = true;
			}
		},
		
		getCardDetails(card){
			let _this = this;
			let params = new URLSearchParams();

			if(card.forum_id){
				params.append('id',		card.forum_id);
			}
			else {
				params.append('id',		card.id);
			}
			params.append('type',		card.type);
			
			this.active_card = {};

			axios({
				url: "CardsGetDetails",
				params: params,

			}).then(function(response) {
				
				_this.active_card = card;
				
				_this.active_card.reply_text = '';
				_this.active_card.replys_loaded = 0;
					
				if(typeof card.type === 'undefined' || card.type === null){
					console.log('card.type not set');
					
				} else if(card.type === 'single'){
					_this.active_card.main_text = response.data.post[card.id].main_text;
					_this.active_card.card_class = 'card_hightlight';
				}
				else if(card.type === 'replys'){
					if(response.data.replys !== null){
						_this.active_card.replies = Object.values(response.data.replys);
					}
					_this.active_card.replys_loaded = 1;
					
				}

				
				
			}).catch(function (error) {
				console.log(error);
			});
		},
		
		getUserDashboardCards(){
			console.log('getUserDashboardCards:');
			let _this = this;
			let params = new URLSearchParams();
			params.append('category',	this.$route.meta.category);
			
			this.dashboard = {};

			axios({
				url: "UserDashboardCardsGet",
				params: params,

			}).then(function(response) {
				//console.log(response.data);
				
				if(response.data.dashboard !== null){
					let entries = response.data.dashboard;
					_this.dashboard = entries;
				}
				
				_this.page_loaded = 1;
				
			}).catch(function (error) {
				console.log(error);
			});
		},
		
		onClick(e, card, type){
			e.preventDefault();
			console.log(type);
			if(type == 'replys'){
				card.type = 'replys';
				this.getCardDetails(card);
				this.$bvModal.show('comments_wrapper');
			}
			else if(type == 'main_text'){
				card.type = 'single';
				this.getCardDetails(card);
			}
			else if(type == 'description'){
				card.main_text = null;
				card.card_class = 'forum';
			}
			else if(type == 'post_reply'){
				card.reply_textarea_show = 1;
				card.reply_text = '';
			}
			else if(type == 'close_comment'){
				card.reply_textarea_show = 0;
				card.reply_open = 0;
				card.replies = null;
			}
			
			/*
			if(card.card_type == 'forum'){
				window.open('https://forum.iamconnected.com/post/' + card.id);
			}
			else
			{
				window.open('https://forum.iamconnected.com' + card.link);
			}*/
			
			/*
			if(card.rel && card.rel == 'external'){
				window.open(item.link);
			}
			else{
				window.location.href = card.link;
			}
			*/
			
		},	
		
		replyAdd(){
			let _this = this;
			
			console.log('replyAdd');
			
			if(this.active_card.reply_text === null || this.active_card.reply_text === ''){
				this.error_message = 'You need to add some content to the Post Reply field!';
				this.canSubmitReply = false;
			}
			else
			{
				this.error_message = '';
				this.canSubmitReply = true;
			}
			
			if(this.canSubmitReply === true){
				let params = new URLSearchParams();
				params.append('token', _this.$store.state.session_id);
				
				if(_this.active_card.forum_id){
					params.append('post_id',	_this.active_card.forum_id);
				}
				else {
					params.append('post_id',	_this.active_card.id);
				}
			
				/*params.append('reply_id', this.reply_id);*/
				
				params.append('title', '');
				params.append('main_text', _this.active_card.reply_text);
	
				axios({
					method: 'post',
					url: "forum/replyAdd",
					data: params,
          headers: {
            // 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
          }
	
				}).then(function (response) {
					if(response.data.status == 1){
						if(typeof response.data.added_data_id !== 'undefined'){
							if(_this.active_card.replies === null){
								_this.active_card.replies = [];
							}
							_this.active_card.replies.push( response.data.added_data[response.data.added_data_id] );
							_this.active_card.reply_text = '';
						}
						_this.active_card.replies_count++;
						_this.$bvModal.hide('comments_wrapper');
					}
					else{
						_this.error_message = response.data.message;
					}
					
				}).catch(function (error) {
					console.log(error);
				});
			}
			
		},
		
		scrollTo(elm_id){
			console.log(elm_id);
			var E = document.getElementById(elm_id).scrollIntoView();
			console.log(E);
		},
	},
	mounted() {
		this.getUserDashboardCards();
	},
	watch: {
		'$route'(to) {
			this.page_loaded = 0;
			this.section_title = to.meta.title;			
			this.getUserDashboardCards();			
		},
	},
};
</script>

<style scoped>
	/* ── Grid ── */
	.card-grid {
		display: grid;
		grid-template-columns: 1fr;
		gap: 1rem;
		align-items: stretch;
	}
	@media screen and (min-width: 768px) {
		.card-grid {
			grid-template-columns: repeat(2, 1fr);
		}
	}

	/* ── Cards ── */
	.dashboard-card {
		display: flex;
		flex-direction: column;
		height: 100%;
		border: 1px solid #f0ece3;
		border-radius: 12px;
		box-shadow: 0 2px 8px rgba(0,0,0,0.04);
		overflow: hidden;
	}
	.dashboard-card:deep(.card-header) {
		padding: 8px 12px;
		background: linear-gradient(135deg, rgba(214,182,116,0.12) 0%, rgba(214,182,116,0.04) 100%);
		border-bottom: 1px solid rgba(214,182,116,0.2);
		font-weight: 600;
		font-size: 0.82rem;
		color: #555;
	}
	.dashboard-card:deep(.card-body) {
		flex: 1;
		padding: 0.75rem;
		max-height: 450px;
		overflow-x: hidden;
		overflow-y: auto;
		scrollbar-width: thin;
		scrollbar-color: rgba(214, 182, 116, 0.5) transparent;
	}
	.dashboard-card:deep(.card-body)::-webkit-scrollbar {
		width: 4px;
	}
	.dashboard-card:deep(.card-body)::-webkit-scrollbar-track {
		background: transparent;
	}
	.dashboard-card:deep(.card-body)::-webkit-scrollbar-thumb {
		background: rgba(214, 182, 116, 0.5);
		border-radius: 10px;
	}
	.dashboard-card:deep(.card-body)::-webkit-scrollbar-thumb:hover {
		background: rgba(214, 182, 116, 0.85);
	}
	.dashboard-card:deep(.card-footer) {
		padding: 6px 12px;
		background: transparent;
		border-top: 1px solid #f5f0e8;
		font-size: 0.8rem;
	}

	/* First two cards (row 1) get a shorter height */
	.card-grid .dashboard-card:nth-child(-n+2):deep(.card-body) {
		max-height: 290px;
	}

	/* ── Countdown Timer ── */
	.timer-wrap {
		text-align: center;
	}

	/* ── No-data state ── */
	.no-data-state {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		padding: 2.5rem 1rem;
		gap: 10px;
	}
	.no-data-state__icon {
		font-size: 2rem;
		color: rgba(214,182,116,0.5);
	}
	.no-data-state__text {
		font-size: 0.8rem;
		color: #bbb;
		margin: 0;
	}

	.card_hightlight {
		border: 2px solid #d1af60;
	}
	#comments_wrapper {
		width: 100%;
		position: absolute;
	}

	.page-header {
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 14px;
    position: relative;
	}
</style>
